import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, NotebookPen } from 'lucide-react';
export function IncludesSection() {
  return <section id="includes" className="w-full bg-cream py-16 md:py-24" data-id="element-182">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-184">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-185">
            Todo lo que recibes hoy — al instante
          </h2>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-186">
            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-187">
              <div className="flex justify-center mb-4" data-id="element-188">
                <BookOpen className="w-16 h-16 text-gold" data-id="element-189" />
              </div>
              <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center" data-id="element-190">
                📘 Ebook principal en PDF
              </h3>
              <p className="text-center font-semibold text-navy mb-4" data-id="element-191">
                "30 Días con Dios" Orden, Provisión y Abundancia
              </p>
              <ul className="space-y-2 text-dark/80 text-sm" data-id="element-192">
                <li data-id="element-193">
                  • Introducción + 4 capítulos base: fe y neuroplasticidad,
                  coherencia interior, creencias limitantes y protocolo
                  R.E.V.E.L.A.
                </li>
                <li data-id="element-194">
                  • 30 días completos con promesa bíblica, declaración de fe,
                  práctica guiada y oración dirigida
                </li>
                <li data-id="element-195">
                  • Dividido en 4 semanas:{' '}
                  <strong data-id="element-196">
                    Limpieza → Alineación → Restauración → Constancia
                  </strong>
                </li>
                <li data-id="element-197">
                  • Checklists, diagnósticos, preguntas de reflexión y
                  worksheets por capítulo
                </li>
                <li data-id="element-198">• FAQ + Glosario + Bendición final (Números 6:24–26)</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-199">
              <div className="flex justify-center mb-4" data-id="element-200">
                <Headphones className="w-16 h-16 text-gold" data-id="element-201" />
              </div>
              <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center" data-id="element-202">
                🎧 4 Meditaciones Guiadas (MP4)
              </h3>
              <p className="text-center font-semibold text-gold mb-4" data-id="element-203">BONO 1</p>
              <ul className="space-y-2 text-dark/80 text-sm" data-id="element-204">
                <li data-id="element-205">• Una meditación al cierre de cada semana</li>
                <li data-id="element-206">
                  • Voz guiada + música para anclar lo aprendido en espíritu y
                  corazón
                </li>
                <li data-id="element-207">• Duración: 10–15 min cada una</li>
                <li data-id="element-208">
                  • Descargables y escuchables sin internet, cuando y donde lo
                  necesites
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-209">
              <div className="flex justify-center mb-4" data-id="element-210">
                <NotebookPen className="w-16 h-16 text-gold" data-id="element-211" />
              </div>
              <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center" data-id="element-212">
                📓 Libreta de Gratitud y Provisión
              </h3>
              <p className="text-center font-semibold text-gold mb-4" data-id="element-213">BONO 2</p>
              <p className="text-center font-semibold text-navy mb-4" data-id="element-214">
                PDF imprimible
              </p>
              <ul className="space-y-2 text-dark/80 text-sm" data-id="element-215">
                <li data-id="element-216">
                  • Un espacio sagrado para presentar tu proceso a Dios por
                  escrito, día a día
                </li>
                <li data-id="element-217">
                  • Plantillas diarias para escribir tu promesa del día, tu
                  declaración de fe, lo que hoy sueltas en oración y tu paso de
                  obediencia
                </li>
                <li data-id="element-218">
                  • Incluye un espacio para registrar tu evidencia del día:
                  dónde viste a Dios obrando hoy
                </li>
                <li data-id="element-219">
                  • Imprimible o usable en tablet: tú decides cómo caminar este
                  proceso
                </li>
              </ul>
            </div>
          </div>

          <blockquote className="border-l-4 border-gold pl-6 py-4 mb-8 bg-white rounded-r-lg max-w-3xl mx-auto" data-id="element-220">
            <p className="italic text-lg md:text-xl font-serif text-navy mb-2" data-id="element-221">
              "Dad gracias en todo, porque esta es la voluntad de Dios para con
              vosotros en Cristo Jesús."
            </p>
            <cite className="text-gold font-semibold not-italic" data-id="element-222">
              1 Tesalonicenses 5:18 (RVR60)
            </cite>
          </blockquote>

          <div className="text-center bg-navy text-white py-4 px-6 rounded-lg inline-block mx-auto" data-id="element-223">
            <p className="font-semibold" data-id="element-224">
              📲 Descarga inmediata — PDF + MP4 — Sin suscripciones — Sin
              esperas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}